import slice from './loadingAnalysesSlice';

export * from './types';
export const {
  setLoadingAnalysesInStoreAction,
  clearAllLoadingAnalysesAction,
  loadAnalysisAction,
} = slice.actions;

export default slice.reducer;
